"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TableBody: function() {
        return _index.TableBody;
    },
    renderTableBody_unstable: function() {
        return _index.renderTableBody_unstable;
    },
    tableBodyClassName: function() {
        return _index.tableBodyClassName;
    },
    tableBodyClassNames: function() {
        return _index.tableBodyClassNames;
    },
    useTableBodyStyles_unstable: function() {
        return _index.useTableBodyStyles_unstable;
    },
    useTableBody_unstable: function() {
        return _index.useTableBody_unstable;
    }
});
const _index = require("./components/TableBody/index");
